import React from 'react'

import {
  string, bool, object, func,
} from 'prop-types'

import UnifiedNavigation from 'Pods/UnifiedNavigation/UnifiedNavigation'
import i18n from 'Pods/Shared/I18n'
function CustomBrowseHead({
  navClass,
  navContainerClass,
  navId,
  navigation,
  isSignedIn,
  openCreateProject
}) {
  const learnMoreHowItWorks = i18n.t('projects.learnMoreHowItWorks', { ns: 'rails', lng: navigation.locale } )
  const startAProject = i18n.t('projects.startAProject', { ns: 'rails', lng: navigation.locale } )
  const projectsDashboard = i18n.t('projects.projectsDashboard', { ns: 'rails', lng: navigation.locale } )
  const cgtraderModelingJob = i18n.t('projects.cgtraderModelingJob', { ns: 'rails', lng: navigation.locale } )

  return (
    <div>
      <div className={navContainerClass}>
        <UnifiedNavigation navClass={navClass} navId={navId} {...navigation} isInFastPage={false} />
      </div>
      <div className="custom-browse-header container-fixed">
        <div className="custom-browse-header__title-container">
          <h1 className="custom-browse-header__title">
            {cgtraderModelingJob}
          </h1>
          <a href="/3d-modeling-jobs" target="_blank">
            {learnMoreHowItWorks}
          </a>
        </div>
        <div className="custom-browse-header__cta-buttons">
          <button className="btn btn-primary" onClick={openCreateProject}>
            {startAProject}
          </button>
          {isSignedIn && (
            <a
              href="/profile/projects"
              className="btn btn-outline-default projects-btn"
            >
              {projectsDashboard}
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

CustomBrowseHead.propTypes = {
  navClass: string.isRequired,
  navContainerClass: string.isRequired,
  navId: string.isRequired,
  navigation: object.isRequired,
  isSignedIn: bool.isRequired,
  openCreateProject: func.isRequired,
}

export default CustomBrowseHead
